import axios from 'axios';
export async function downloadFile (url, name) {
  const res = await axios.get(`${url}?${+new Date()}`, { responseType: 'blob' });
  let type = res.headers['content-type'];
  let blob = new Blob([res.data], { type: `${type};charset=utf-8` });
  let path = URL.createObjectURL(blob);
  // 创建一个下载标签<a>
  const aLink = document.createElement('a');
  aLink.href = path;
  // 2.直接使用自定义文件名,设置下载文件名称
  aLink.setAttribute('download', name);
  document.body.appendChild(aLink);
  // 模拟点击下载
  aLink.click();
  // 移除改下载标签
  document.body.removeChild(aLink);
}